import { Dispatch } from "redux";
import { FGetState } from "../app.reducer";
import androidType from "./android.type";

const appSendData = (dataApp : any) => {
	return async (dispatch: Dispatch, getState: FGetState) => {
		dispatch({
			type: androidType.APP_CONNECT.START,
			payload: dataApp
		});
	};
};
const cleanDataApp = () => {
    return async (dispatch: Dispatch, _getState: FGetState) => {
        dispatch({
            type: androidType.APP_CONNECT.END,
        });
    };
};

export default {
	appSendData,
	cleanDataApp
} as const;